import { colorsPalette, styled } from '@lingoda/ui';

export const StyledHorizontalLine = styled('div')(({ theme }) => ({
    height: 'auto',
    minHeight: '28px',
    width: theme.spacing(1),
    borderRadius: '5px',
    marginRight: theme.spacing(2),
    backgroundColor: colorsPalette.darkblueSolid[12],
}));
